import { useState, useCallback } from 'react';
import { toast } from 'react-toastify';

import { getMicrophoneStream } from '../../utils/speechUtils';

export const MediaPermissionsState = {
    PROMPT: 'prompt',
    GRANTED: 'granted',
    DENIED: 'denied',
};

export const useRequestMicPermissions = () => {
    const [permissionState, setPermissionState] = useState(null);

    const requestPermissions = useCallback(async () => {
        try {
             // First check if permissions are already granted
        const permissionStatus = await navigator.permissions.query({ name: 'microphone' });
        
        if (permissionStatus.state === MediaPermissionsState.GRANTED) {
            setPermissionState(MediaPermissionsState.GRANTED);
            toast.success('Microphone access already granted');
            return true;
        }

            const stream = await getMicrophoneStream();
            setPermissionState(MediaPermissionsState.GRANTED);

            // Stop all tracks to release the microphone
            stream.getTracks().forEach(track => track.stop());

            toast.success('Microphone access granted');

            return true;
        } catch (err) {
            console.error('Error requesting microphone permission:', err);
            // setPermissionState(MediaPermissionsState.DENIED);
             // Check if it's a permission denied error
        if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
            toast.error('Microphone access denied. Please enable it in your browser settings.');
            setPermissionState(MediaPermissionsState.DENIED);
        } else {
            // For other errors, suggest browser refresh
            toast.error('Could not access microphone. Try refreshing the page.');
            setPermissionState(MediaPermissionsState.PROMPT);
        }
            return false;
        }
    }, []);

    const checkPermissions = useCallback(async () => {
        try {
            const result = await navigator.permissions.query({ name: 'microphone' });
            setPermissionState(result.state);
        } catch (err) {
            console.error('Error checking microphone permission:', err);
            setPermissionState(MediaPermissionsState.PROMPT);
        }
    }, []);

    return {
        permissionState,
        requestPermissions,
        checkPermissions,
    };
};